import { createElement } from 'react'
import type { ComponentProps } from 'react'
import type { Legend, Tooltip } from 'recharts'
import { productThemes } from '@/lib/productBranding'

// Shared Recharts styling for Agent Builder charts. Ported from mockups/charts.js.
// Charts pass their own full-value formatter to the tooltip; chartTooltipProps has none.

export const CHART_GRID_COLOR = '#eef1f4'
export const CHART_AXIS_TICK = { fontSize: 11, fill: '#667085' } as const
export const CHART_AXIS_LINE_COLOR = '#d0d6de'
export const CHART_CATEGORY_TICK = { fontSize: 12.5, fill: '#1d2433' } as const
export const CHART_BAR_TRACK = { fill: '#f5f7f9', radius: 6 } as const
export const CHART_VALUE_LABEL_STYLE = { fontSize: 12, fontWeight: 600, fill: '#1d2433' } as const
export const CHART_LINE_COLOR = '#14a597'

export const CHART_SERIES_COLORS: readonly string[] = [
  productThemes.pracIntel.primary,
  '#4a7fc1',
  '#2a9d8f',
  '#7b8fbd',
  '#f59e0b',
  '#7c3aed',
]

export const DONUT_COLORS: readonly string[] = ['#00c8b9', '#2fa6c9', '#66c2a5', '#f59e0b', '#ef4444', '#7c3aed']

export function getSeriesColor(index: number): string {
  const length = CHART_SERIES_COLORS.length
  const color = CHART_SERIES_COLORS[((index % length) + length) % length]
  return color ?? productThemes.pracIntel.primary
}

export const chartTooltipProps = {
  contentStyle: {
    borderRadius: 8,
    border: '1px solid #e6eaef',
    boxShadow: '0 4px 14px rgba(16,24,40,0.08)',
    fontSize: 12,
    padding: '8px 12px',
  },
  labelStyle: { color: '#1d2433', fontWeight: 600, marginBottom: 4 },
  itemStyle: { padding: 0 },
  cursor: { fill: 'rgba(0,199,183,0.06)', stroke: '#cfd8e0' },
} satisfies ComponentProps<typeof Tooltip>

export const chartLegendProps = {
  verticalAlign: 'top',
  align: 'right',
  iconType: 'circle',
  iconSize: 8,
  height: 28,
  formatter: (value: string) => createElement('span', { style: { color: '#475467', fontSize: 12 } }, value),
} satisfies ComponentProps<typeof Legend>
